import{_ as r}from"./_coreJsData.js";var e,s=r,a=(e=/[^.]+$/.exec(s&&s.keys&&s.keys.IE_PROTO||""))?"Symbol(src)_1."+e:"";var o=function(r){return!!a&&a in r};export{o as _};
